import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "116",
  height: "101",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7B0BA",
      d: "M16.374 88.782a5 5 0 0 1-.271-1.615V10.36a4.99 4.99 0 0 1 4.99-4.99h33.636c1.632 0 3.207.6 4.423 1.688l9.077 8.093a6.63 6.63 0 0 0 4.422 1.687h37.859a4.99 4.99 0 0 1 4.99 4.99v68.433L16.374 88.79z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D3D7DC",
      d: "m.684 34.65 15.89 57.187a5.18 5.18 0 0 0 4.982 3.791h88.762c3.415 0 5.894-3.247 4.99-6.542L102.057 40.76a4.98 4.98 0 0 0-4.806-3.67H54.68a6.7 6.7 0 0 1-3.375-.92l-11.748-6.926a6.7 6.7 0 0 0-3.374-.92H5.49c-3.295 0-5.686 3.143-4.806 6.318z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#A7B0BA",
      d: "M26.884 39.448a1.855 1.855 0 1 0 0-3.71 1.855 1.855 0 0 0 0 3.71M19.086 39.448a1.855 1.855 0 1 0 0-3.71 1.855 1.855 0 0 0 0 3.71M11.281 39.448a1.855 1.855 0 1 0 0-3.71 1.855 1.855 0 0 0 0 3.71"
    }, null, -1)
  ]))]))
}
export default { render: render }